module.exports = __webpack_public_path__ + "img/netstar-loader_new.c25e2e18.gif";